<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <!-- 添加按钮 -->
      <template #start>
        <el-form-item v-if="user && ![2, 3, 4].includes(user.user_group_id)" class="startBtn">
          <el-button type="primary" icon="el-icon-plus" @click="addOrder">添加</el-button>
        </el-form-item>
      </template>
      <!-- 复合搜索框 -->
      <template #beforeBtn>
        <CompositeFormCtrl v-if="!$route.path.includes('/contract/orderlist')" ref="comFormCtrl" :options="searchKeyOptions" @onChange="onComSearchChange">
        </CompositeFormCtrl>
      </template>
      <!-- 导出按钮 -->
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`合同运单_自有车辆_待接单`)">导出</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      :tableHeight="tableHeight" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template slot="btn1" slot-scope="params">
        <el-button class="positionbtn" type="primary" @click="showPosition(params.params)" size="mini">位置</el-button>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";
import ordermixin from "../../../nonContractOrder/own/mixin";
import mixin from "../mixin";

export default {
  mixins: [tableMixin, ordermixin, mixin],
  data() {
    return {
      formInline: {
        order_type: 2,
        ischeck: 1,
        isstatus: 1,
      },
      cols: [
        { keyName: "con_num", label: "合同编号", minwidth: 120 },
        { keyName: "order_num", label: "运单编号", minwidth: 150 },
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名", minwidth: 110 },
        { keyName: "shname", label: "客户名称", minwidth: 120 },
        { keyName: "name", label: "货物名称", minwidth: 110  },
        { keyName: "pricing", label: "计价方式", minwidth: 110  },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
        { ...this.ctrls.ZhuangHuoRiQi, },
        { keyName: "", label: "位置", slot: 'btn1' },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: ({ id }) => {
            let path = `/order/contractview`
            if (this.$route.path.includes('/contract/orderlist')) {
              path = '/contract/orderview'
            }
            this.$router.push({
              path,
              query: {
                id,
                mode: 'edit',
              }
            });
          },
        },
        {
          ...this.delBtn,
          cb: this.delete,
        },
      ],
    };
  },
  methods: {
    addOrder() {
      this.$router.push("/order/contractadd");
    },
  },
  mounted() {
    const { user_group_id } = this.user
    if ([2, 3, 4].includes(user_group_id)) {
      this.btns.length = 1
      this.cols.splice(this.cols.length - 1, 1)
      this.btns[0] = {
        ...this.viewBtn,
        cb: ({ id }) => {
          let path = `/order/contractview1`
          if (this.$route.path.includes('/contract/orderlist')) {
            path = '/contract/orderview1'
          }
          this.$router.push({
            path,
            query: {
              id,
              mode: 'view',
            }
          });
        },
      }
    }
  },
};
</script>
